import React from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { GetAddonsCommissionsReport } from '../../../api/services/finance'
import { DatePicker } from '../../shared/DatePicker'
import { Form } from 'semantic-ui-react'
import { useTextResources } from '../../../language'
import moment from 'moment'
import { endpoint } from '../../../api/http'
import { dateFormat } from '../../shared/constants'

const AddonsCommissionsReport = () => {
    const text = useTextResources()
    const formatter = ({ value }) => {
        return value && value.toFixed(2)
    }

    const dateFormatter = ({ value }) => {
        return value && moment(value).format(dateFormat)
    }

    /* eslint-disable react/prop-types */
    const reservationFormatter = ({ value, row }) => {
        return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}PMS/Reservations/Index/${row.ReservationId}?hotelid=${row.HotelId}`}>{value}</a>
    }
    /* eslint-enable react/prop-types */

    const gridOptions = {
        search: {
            title: text("AddonsChannelCommissionsReport"),
            description: text("AddonCommissionsByChannel"),
            fields: [
                <DatePicker
                    type="basic"
                    label={text("StartDate")}
                    name="StartDate"
                    key="StartDate"
                />,
                <DatePicker
                    type="basic"
                    label={text("EndDate")}
                    name="EndDate"
                    key="EndDate"
                />,
                <Form.Field control={HotelsDropDown} width="4" multiple label={text("Hotel")} key="HotelIDs" />
            ],
            api: GetAddonsCommissionsReport
        },
        grid: {
            columns: [
                { name: 'HotelName', title: text('Hotel') },
                { name: 'ReservationNumber', title: text('Reservation'), formatter: reservationFormatter },
                { name: 'Status', title: text('Status') },
                { name: 'Nationality', title: text('Nationality') },
                { name: 'CheckInDate', title: text('CheckInDate'), formatter: dateFormatter },
                { name: 'CheckOutDate', title: text('CheckOutDate'), formatter: dateFormatter },
                { name: 'SumChannelCommision', title: text('ChannelCommission'), formatter },
                { name: 'AgentName', title: text('Agent') },
                { name: 'CompanyName', title: text('Company') },
                { name: 'Currency', title: text('Currency') }
            ],
            pdf: true,
            export: true,
            summary: true,
            totalSummaryItems: [
                { columnName: 'SumChannelCommision', type: 'sum' }
            ]
        }
    }
    return (<GridSearchTemplate options={gridOptions} />)
}

export default AddonsCommissionsReport